import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aad5ab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["stroke", "d"]
const _hoisted_2 = ["points"]
const _hoisted_3 = ["x", "y"]

import { reactive, isReactive, computed, ref } from "vue";
import { EdgeProps, getEdgeCenter } from "@braks/vue-flow";
interface CustomConnectionLineProps extends EdgeProps {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  id: string;
  label: string;
  style: object;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EditableConnection',
  props: {
    sourceX: {},
    sourceY: {},
    targetX: {},
    targetY: {},
    id: {},
    label: {},
    style: {},
    selected: { type: Boolean },
    sourcePosition: {},
    targetPosition: {},
    markerEndId: {},
    sourceHandleId: {},
    targetHandleId: {},
    sourceNode: {},
    targetNode: {},
    type: {},
    source: {},
    target: {},
    sourceHandle: {},
    targetHandle: {},
    labelStyle: {},
    labelShowBg: { type: Boolean },
    labelBgStyle: {},
    labelBgPadding: {},
    labelBgBorderRadius: {},
    animated: { type: Boolean },
    arrowHeadType: {},
    data: {},
    class: {},
    isHidden: { type: Boolean },
    updatable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



let dragOffsetX = ref(null);
let dragOffsetY = ref(null);
let isDragging = ref(false);

const cursor = computed(
  () => `cursor: ${isDragging.value ? "grabbing" : "grab"}`
);

const getCenterFromNodes = computed(() =>
  getEdgeCenter({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    targetX: props.targetX,
    targetY: props.targetY,
  })
);
const getCenterFromDrag = reactive({ x: 0.0, y: 0.0 });
const getCenter = computed(function () {
  const center = {
    x: getCenterFromNodes.value[0] + getCenterFromDrag.x,
    y: getCenterFromNodes.value[1] + getCenterFromDrag.y,
  };
  // console.log("center", center);
  return center;
});

const drag = (e) => {
  // console.log("onmousedown label ");
  // e.target.style.fill = "#f00";
  dragOffsetX.value = e.offsetX;
  dragOffsetY.value = e.offsetY;
  isDragging.value = true;
  window.addEventListener("mouseup", drop);
};

const move = (e) => {
  if (isDragging.value === true) {
    // console.log("move label");
    // e.target.style.fill = "#00f";
    const transform = JSON.parse(
      "[" +
        getComputedStyle(document.querySelectorAll("g")[0])
          .transform.replace("matrix(", "")
          .replace(")", "") +
        "]"
    );
    getCenterFromDrag.x += (e.offsetX - dragOffsetX.value) * transform[0];
    getCenterFromDrag.y += (e.offsetY - dragOffsetY.value) * transform[0];
  }
};

const drop = (e) => {
  if (isDragging.value === true) {
    // console.log("drop label");
    // square.value.style.fill = "#0f0";
    isDragging.value = false;
    window.removeEventListener("mouseup", drop);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", null, [
    _createElementVNode("path", {
      fill: "none",
      stroke: props.style.stroke,
      "stroke-width": 1.5,
      d: `M${props.sourceX},${props.sourceY} 
           h 20
           C ${props.sourceX + 100} ${props.sourceY} ${getCenter.value.x} ${
        getCenter.value.y
      } 
           ${getCenter.value.x},${getCenter.value.y}
           C ${getCenter.value.x} ${getCenter.value.y}  ${props.targetX - 100} ${
        props.targetY
      } 
           ${props.targetX - 20} ${props.targetY} 
           h 20`
    }, null, 8, _hoisted_1),
    _createElementVNode("polygon", {
      fill: "#222",
      stroke: "#222",
      points: `${props.targetX},${props.targetY} ${props.targetX - 10},${
        props.targetY - 4
      } ${props.targetX - 10},${props.targetY + 4}`
    }, null, 8, _hoisted_2),
    _createElementVNode("g", {
      "pointer-events": "visibleFill",
      onMousedown: drag,
      onMousemove: move,
      style: _normalizeStyle(cursor.value)
    }, [
      _createElementVNode("text", {
        x: getCenter.value.x + 5,
        y: getCenter.value.y,
        class: "disable-select label",
        stroke: "#222",
        "stroke-width": 0.2
      }, _toDisplayString(props.label), 9, _hoisted_3)
    ], 36)
  ]))
}
}

})